import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  TextField,
  Paper,
  InputAdornment,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LoadingButton from '../components/LoadingButton'
import { poInquiryReactTableCols } from '../constants/PoCols'
import DateInput from '../components/DateInput'
import { smallScreenWidth } from '../constants/AppConstants'
import { DashboardAthenaTableServerSideNoSelect } from '../components/DashboardAthenaTableServerSideNoSelect'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import OpenSearchDropdown from '../components/OpenSearchDropdown'

const _ = require('lodash')

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const startAdornment = (
  <>
    <InputAdornment position='start'>
      <div></div>
    </InputAdornment>
  </>
)
const defaultHeaders = {
  company: '',
  fromDate: '',
  toDate: '',
  vendorGroup: '',
  vendor: '',
  vendorLoc: '',
  buyer: '',
  status: '',
  poCode: '',
  poNumber: '',
  totalAmt: '',
  totalLines: ''
}

export default function PoInquiry (props) {
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    fetched: true,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [clearHeader, setClearHeaders] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)

  const classes = useStyles()

  const { credentials } = props.fetchInitialData


  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false });
      setShowTable(false);
      return null;
    }
    setstate({ ...state, isLoading: false });
  };

  const tableDataTransformation = (rows) => {
    return rows.map(row => {
          return {
            ...row,
            PO_LINK:
              row.PO_NUMBER && row.COMPANY ? (
                <div
                  className='editLink'
                  onClick={() => {
                    const win = window.open(
                      `/po?company=${row.COMPANY}&po=${row.PO_NUMBER}&pocode=${row.PO_CODE}`,
                      '_blank'
                    )
                    win.focus()
                  }}
                >
                  {row.PO_NUMBER}
                </div>
              ) : (
                ''
              )
          }
        })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (JSON.stringify(headers) === state.tableKey) return null;
    setShowTable(true);
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) });
  };

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Purchase Order Search
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='250px'
                  label='Company'
                  page="PO"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, company: val?.VALUE || '' })
                  }}
                />
              </Grid>
              {[
                {
                  id: 'fromDate',
                  label: 'From Date'
                },
                {
                  id: 'toDate',
                  label: 'To Date'
                }
              ].map(field => {
                return (
                  <Grid key={field.id} item>
                    <DateInput
                      id={field.id}
                      key={clearHeader}
                      type={'date'}
                      required={true}
                      label={field.label}
                      value={headers[field.id]}
                      onChange={e => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null
                        })
                      }}
                      variant='standard'
                    />
                  </Grid>
                )
              })}

              <Grid item>
                <OpenSearchDropdown
                  id='vendorGroup'
                  required={false}
                  width='125px'
                  label='Vendor Group'
                  page="VENDOR"
                  entity="VENDORGROUP"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, vendorGroup: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='vendor'
                  required={false}
                  disabled={!headers.vendorGroup}
                  width='125px'
                  label='Vendor'
                  page="VENDOR"
                  entity="VENDOR"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    VENDORGROUP: headers.vendorGroup
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, vendor: val?.VALUE || '' })
                  }}
                />
              </Grid>

              <Grid item>
                <OpenSearchDropdown
                  id='vendorLoc'
                  required={false}
                  disabled={!headers.vendor}
                  width='125px'
                  label='Location'
                  page="VENDOR"
                  entity="LOCATION"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    VENDOR: headers.vendor
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, vendorLoc: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='buyer'
                  required={false}
                  width='125px'
                  label='Buyer'
                  page="POINQUIRY"
                  entity="BUYER"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, buyer: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='status'
                  required={false}
                  width='125px'
                  label='Status'
                  page="POINQUIRY"
                  entity="STATUS"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, status: val?.VALUE || '' })
                  }}
                />
              </Grid>

              <Grid item>
                <OpenSearchDropdown
                  id='poNumber'
                  required={false}
                  disabled={!headers.company}
                  width='175px'
                  label='PO Number'
                  page="PO"
                  entity="PONUM"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    COMPANY: headers.company
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, poNumber: val?.VALUE || '', poCode: val?.POCODE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  id='poCode'
                  label='PO Code'
                  style={{ width: '125px', paddingTop: '8px' }}
                  variant='standard'
                  value={headers.poCode}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item>
                <TextField
                  id='totalAmt'
                  label='Total Amount'
                  style={{ width: '125px', paddingTop: '8px' }}
                  variant='standard'
                  value={headers.totalAmt}
                  onChange={e =>
                    setHeaders({ ...headers, totalAmt: e.target.value })
                  }
                />
              </Grid>
              <Grid item>
                <TextField
                  id='totalLines'
                  label='Total Lines'
                  style={{ width: '125px', paddingTop: '8px' }}
                  variant='standard'
                  value={headers.totalLines}
                  onChange={e =>
                    setHeaders({ ...headers, totalLines: e.target.value })
                  }
                />
              </Grid>
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!(
                headers.company ||
                headers.fromDate ||
                headers.toDate ||
                headers.vendorGroup ||
                headers.vendor ||
                headers.vendorLoc ||
                headers.buyer ||
                headers.status ||
                headers.poCode ||
                headers.poNumber ||
                headers.totalAmt ||
                headers.totalLines
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                    setShowTable(false)
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {showTable && (
          <div style={{ marginTop: '1rem ' }}>

<DashboardAthenaTable
          {...props}
          isTempTable={true}
          key={state.tableKey}
          params={{ ...headers }}
          tableColumns={poInquiryReactTableCols}
          reportParamName="po_inquiry_serverside"
          reportName='po_inquiry_serverside_temp'
          tableTitle={''}
          callback={handleCallback}
          transform={tableDataTransformation}
          downloadFileName={'Po_Inquiry_Download'}
        />

          </div>
        )}
      </div>
    </div>
  )
}
